import {
  getAIAssistantAnalysisUrl,
  getAIAssistantCatalogRefreshUrl,
  getAIAssistantChatbotUrl,
  getAIAssistantEnabledFeaturesUrl,
  getAIAssistantEnginesUrl,
  getAIAssistantEngineUrl,
  getAIAssistantFeaturesUrl,
  getAIAssistantMetadataUrl,
  getAIAssistantSettingsAuthUrl,
  getAIAssistantSettingsChangePwdUrl,
  getCreateViewUrl,
  getNodesConfigUrl
} from "../../constants/apiEndpoints";
import {initRequest, RequestMethod} from "../../middlewares/request/requestActions";
import {getCompleteODataBaseUrl} from "../../utils/odata";

export const AI_ASSISTANT_STATE_RESET = "ai-assistant/state/reset";

export const AI_ASSISTANT_CHATBOT_DIALOG_VISIBILITY_SET = "ai-assistant/chatbot/dialog-visibility/set";
export const AI_ASSISTANT_CHATBOT_USER_MESSAGE_CHANGE = "ai-assistant/chatbot/user-message/change";
export const AI_ASSISTANT_CHATBOT_CHAT_RESET = "ai-assistant/chatbot/chat/reset";
export const AI_ASSISTANT_CHATBOT_CHAT_ENTRY_ADD = "ai-assistant/chatbot/chat/entry/add";
export const AI_ASSISTANT_CHATBOT_REQUEST_SEND = "ai-assistant/chatbot/request/send";
export const AI_ASSISTANT_CHATBOT_REQUEST_STOP = "ai-assistant/chatbot/request/stop";
export const AI_ASSISTANT_CHATBOT_MESSAGE_UPDATE = "ai-assistant/chatbot/message/update";
export const AI_ASSISTANT_CHATBOT_PACKAGE_ID_SET = "ai-assistant/chatbot/package-id/set";
export const AI_ASSISTANT_CHATBOT_LAST_QUERY_SET = "ai-assistant/chatbot/last-query/set";

export const AI_ASSISTANT_METADATA_FETCH = "ai-assistant/metadata/fetch";

export const AI_ASSISTANT_ANALYSIS_FETCH = "ai-assistant/analysis/fetch";

export const AI_ASSISTANT_VIEW_SUBMIT = "ai-assistant/view/submit";
export const AI_ASSISTANT_VIEW_ERROR_HIDE = "ai-assistant/view/error/hide";

export const AI_ASSISTANT_CATALOG_REFRESH = "ai-assistant/catalog/refresh";

export const AI_ASSISTANT_AI_SETTINGS_AUTHORIZATION_REQUEST = "ai-assistant/ai-settings/authorization/request";
export const AI_ASSISTANT_AI_SETTINGS_CHANGE_PASSWORD_REQUEST = "ai-assistant/ai-settings/change/password/request";
export const AI_ASSISTANT_NODES_FETCH = "ai-assistant/nodes/fetch";

export const AI_ASSISTANT_AI_SETTINGS_MODAL_SHOW = "ai-assistant/ai-settings/modal/show";
export const AI_ASSISTANT_AI_SETTINGS_MODAL_HIDE = "ai-assistant/ai-settings/modal/hide";
export const AI_ASSISTANT_AI_SETTINGS_FETCH = "ai-assistant/ai-settings/fetch";
export const AI_ASSISTANT_AI_SETTINGS_SUBMIT = "ai-assistant/ai-settings/submit";

export const AI_ASSISTANT_SEARCH_ENGINE_LIST_MODAL_SHOW = "ai-assistant/search-engine-list/modal/show";
export const AI_ASSISTANT_SEARCH_ENGINE_LIST_MODAL_HIDE = "ai-assistant/search-engine-list/modal/hide";
export const AI_ASSISTANT_SEARCH_ENGINE_LIST_FETCH = "ai-assistant/search-engine-list/fetch";
export const AI_ASSISTANT_SEARCH_ENGINE_SETTINGS_MODAL_SHOW = "ai-assistant/search-engine-settings/modal/show";
export const AI_ASSISTANT_SEARCH_ENGINE_SETTINGS_MODAL_HIDE = "ai-assistant/search-engine-settings/modal/hide";
export const AI_ASSISTANT_SEARCH_ENGINE_SETTINGS_FETCH = "ai-assistant/search-engine-settings/fetch";
export const AI_ASSISTANT_SEARCH_ENGINE_SETTINGS_SUBMIT = "ai-assistant/search-engine-settings/submit";
export const AI_ASSISTANT_SEARCH_ENGINE_SETTINGS_DELETE = "ai-assistant/search-engine-settings/delete";
export const AI_ASSISTANT_AI_FEATURES_FETCH = "ai-assistant/ai-features/fetch";

const authTokenHeaderName = "dataportal-ai-auth-token";

export const resetAiAssistantState = () => ({
  type: AI_ASSISTANT_STATE_RESET
});

export const setAiAssistantChatbotDialogVisibility = visibility => ({
  type: AI_ASSISTANT_CHATBOT_DIALOG_VISIBILITY_SET,
  payload: {
    visibility: visibility
  }
});

export const changeAiAssistantChatbotUserMessage = (message, append) => ({
  type: AI_ASSISTANT_CHATBOT_USER_MESSAGE_CHANGE,
  payload: {
    message: message,
    append: append
  }
});

export const resetAiAssistantChatbotChat = () => ({
  type: AI_ASSISTANT_CHATBOT_CHAT_RESET
});

export const addAiAssistantChatbotEntry = entry => ({
  type: AI_ASSISTANT_CHATBOT_CHAT_ENTRY_ADD,
  payload: {
    entry: entry
  }
});

export const sendAiAssistantChatbotRequest = (
  nodeId,
  sessionId,
  message,
  packageId,
  catalog,
  ODataBaseUrl,
  baseUrl,
  lastQuery,
  extras = {}
) => {
  const resolvedODataBaseUrl = getCompleteODataBaseUrl(ODataBaseUrl);
  return initRequest(
    AI_ASSISTANT_CHATBOT_REQUEST_SEND,
    getAIAssistantChatbotUrl(nodeId, packageId),
    RequestMethod.POST,
    {
      Query: message,
      SessionId: sessionId,
      ODataBaseUrl: resolvedODataBaseUrl,
      ODataLastQuery: packageId ? lastQuery : undefined
    },
    undefined,
    {
      nodeId: nodeId,
      sessionId: sessionId,
      message: message,
      packageId: packageId,
      catalog: catalog,
      ODataBaseUrl: ODataBaseUrl,
      baseUrl: baseUrl,
      ...extras
    },
    baseUrl,
    undefined,
    true
  );
};

export const stopAiAssistantChatbotRequest = () => ({
  type: AI_ASSISTANT_CHATBOT_REQUEST_STOP
});

export const updateAiAssistantChatbotMessage = (messageIdx, updates) => ({
  type: AI_ASSISTANT_CHATBOT_MESSAGE_UPDATE,
  payload: {
    messageIdx: messageIdx,
    updates: updates
  }
});

export const setAiAssistantChatbotPackageId = packageId => ({
  type: AI_ASSISTANT_CHATBOT_PACKAGE_ID_SET,
  payload: {
    packageId: packageId
  }
});

export const setAiAssistantChatbotLastQuery = lastQuery => ({
  type: AI_ASSISTANT_CHATBOT_LAST_QUERY_SET,
  payload: {
    lastQuery: lastQuery
  }
});

export const fetchAiAssistantMetadata = (nodeId, packageId, ODataBaseUrl, baseUrl) => {
  const resolvedODataBaseUrl = getCompleteODataBaseUrl(ODataBaseUrl);
  return initRequest(
    AI_ASSISTANT_METADATA_FETCH,
    getAIAssistantMetadataUrl(nodeId, packageId),
    RequestMethod.POST,
    resolvedODataBaseUrl,
    t => ({
      onStart: t("modules.aiAssistant.actions.messages.getMetadata")
    }),
    undefined,
    baseUrl,
    undefined,
    undefined,
    "application/json"
  );
};

export const fetchAiAssistantAnalysis = (
  nodeId,
  packageId,
  resourceId,
  message,
  sessionId,
  dataToAnalyze,
  isAnalysisPartial,
  ODataBaseUrl,
  baseUrl,
  extras = {}
) => {
  const resolvedODataBaseUrl = getCompleteODataBaseUrl(ODataBaseUrl);
  return initRequest(
    AI_ASSISTANT_ANALYSIS_FETCH,
    getAIAssistantAnalysisUrl(nodeId, packageId, resourceId),
    RequestMethod.POST,
    {
      Query: message,
      SessionId: sessionId,
      Data: dataToAnalyze,
      ODataBaseUrl: resolvedODataBaseUrl
    },
    undefined,
    {
      analyzedPartially: isAnalysisPartial,
      analyzedDataCount: dataToAnalyze.length,
      ...extras
    },
    baseUrl,
    undefined,
    true
  );
};

// View Save
export const submitAiAssistantView = (nodeId, view) =>
  initRequest(
    AI_ASSISTANT_VIEW_SUBMIT,
    getCreateViewUrl(nodeId),
    RequestMethod.POST,
    view,
    t => ({
      onStart: t("scenes.dataset.actions.savingView")
    }),
    undefined,
    undefined,
    statusCode => statusCode === 409
  );

export const hideAiAssistantViewError = () => ({
  type: AI_ASSISTANT_VIEW_ERROR_HIDE
});

export const refreshAiAssistantCatalog = (nodeId, baseUrl) =>
  initRequest(
    AI_ASSISTANT_CATALOG_REFRESH,
    getAIAssistantCatalogRefreshUrl(nodeId),
    RequestMethod.GET,
    undefined,
    t => ({
      onStart: t("modules.aiAssistant.actions.messages.refreshCatalog")
    }),
    undefined,
    baseUrl
  );

// AI Node Settings

export const requestAiSettingsAuthorization = (password, baseUrl) =>
  initRequest(
    AI_ASSISTANT_AI_SETTINGS_AUTHORIZATION_REQUEST,
    getAIAssistantSettingsAuthUrl(),
    RequestMethod.POST,
    {
      Password: password?.length > 0 ? btoa(password) : undefined
    },
    t => ({
      onStart: t("modules.aiAssistant.aiSettings.requestAuthorization")
    }),
    undefined,
    baseUrl
  );

export const requestAiSettingsChangePassword = (currentPassword, newPassword, baseUrl) =>
  initRequest(
    AI_ASSISTANT_AI_SETTINGS_CHANGE_PASSWORD_REQUEST,
    getAIAssistantSettingsChangePwdUrl(),
    RequestMethod.PUT,
    {
      CurrentPassword: currentPassword?.length > 0 ? btoa(currentPassword) : undefined,
      NewPassword: newPassword?.length > 0 ? btoa(newPassword) : undefined
    },
    t => ({
      onStart: t("modules.aiAssistant.aiSettings.changePassword")
    }),
    undefined,
    baseUrl
  );

export const fetchNodes = () =>
  initRequest(AI_ASSISTANT_NODES_FETCH, getNodesConfigUrl(), undefined, undefined, t => ({
    onStart: t("scenes.nodesSettings.messages.fetchNodes.start")
  }));

export const showNodeAISettingsModal = nodeId => ({
  type: AI_ASSISTANT_AI_SETTINGS_MODAL_SHOW,
  payload: {
    nodeId
  }
});

export const hideNodeAISettingsModal = () => ({
  type: AI_ASSISTANT_AI_SETTINGS_MODAL_HIDE
});

export const fetchNodeAiSettings = (nodeId, baseUrl, authToken) =>
  initRequest(
    AI_ASSISTANT_AI_SETTINGS_FETCH,
    getAIAssistantFeaturesUrl(nodeId),
    RequestMethod.GET,
    undefined,
    t => ({
      onStart: t("modules.aiAssistant.aiSettings.getSettings")
    }),
    undefined,
    baseUrl,
    statusCode => statusCode === 401,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    {[authTokenHeaderName]: authToken}
  );

export const submitNodeAiSettings = (nodeId, formData, baseUrl, authToken) =>
  initRequest(
    AI_ASSISTANT_AI_SETTINGS_SUBMIT,
    getAIAssistantFeaturesUrl(nodeId),
    RequestMethod.POST,
    {...formData},
    t => ({
      onStart: t("modules.aiAssistant.aiSettings.submitSettings")
    }),
    undefined,
    baseUrl,
    statusCode => statusCode === 401,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    {[authTokenHeaderName]: authToken}
  );

// AI Search Engines
export const showSearchEngineListModal = () => ({
  type: AI_ASSISTANT_SEARCH_ENGINE_LIST_MODAL_SHOW
});

export const hideSearchEngineListModal = () => ({
  type: AI_ASSISTANT_SEARCH_ENGINE_LIST_MODAL_HIDE
});

export const fetchSearchEngines = (nodeId, baseUrl, authToken) =>
  initRequest(
    AI_ASSISTANT_SEARCH_ENGINE_LIST_FETCH,
    getAIAssistantEnginesUrl(nodeId),
    RequestMethod.GET,
    undefined,
    t => ({
      onStart: t("modules.aiAssistant.aiSettings.searchEngines.getList")
    }),
    undefined,
    baseUrl,
    statusCode => statusCode === 401,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    {[authTokenHeaderName]: authToken}
  );

export const showSearchEngineSettingsModal = searchEngineId => ({
  type: AI_ASSISTANT_SEARCH_ENGINE_SETTINGS_MODAL_SHOW,
  payload: {
    searchEngineId
  }
});

export const hideSearchEngineSettingsModal = () => ({
  type: AI_ASSISTANT_SEARCH_ENGINE_SETTINGS_MODAL_HIDE
});

export const fetchSearchEngineSettings = (nodeId, engineId, baseUrl, authToken) =>
  initRequest(
    AI_ASSISTANT_SEARCH_ENGINE_SETTINGS_FETCH,
    getAIAssistantEngineUrl(nodeId, engineId),
    RequestMethod.GET,
    undefined,
    t => ({
      onStart: t("modules.aiAssistant.aiSettings.searchEngines.getSettings")
    }),
    undefined,
    baseUrl,
    statusCode => statusCode === 401,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    {[authTokenHeaderName]: authToken}
  );

export const submitSearchEngineSettings = (nodeId, searchEngineId, formData, baseUrl, authToken) =>
  initRequest(
    AI_ASSISTANT_SEARCH_ENGINE_SETTINGS_SUBMIT,
    getAIAssistantEnginesUrl(nodeId),
    RequestMethod.POST,
    {...formData, id: searchEngineId},
    t => ({
      onStart: t("modules.aiAssistant.aiSettings.searchEngines.submitSettings")
    }),
    undefined,
    baseUrl,
    statusCode => statusCode === 401,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    {[authTokenHeaderName]: authToken}
  );

export const deleteSearchEngine = (nodeId, engineId, baseUrl, authToken) =>
  initRequest(
    AI_ASSISTANT_SEARCH_ENGINE_SETTINGS_DELETE,
    getAIAssistantEngineUrl(nodeId, engineId),
    RequestMethod.DELETE,
    undefined,
    t => ({
      onStart: t("modules.aiAssistant.aiSettings.searchEngines.deleteEngine")
    }),
    undefined,
    baseUrl,
    statusCode => statusCode === 401,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    {[authTokenHeaderName]: authToken}
  );

export const fetchNodeAiFeatures = (nodeId, baseUrl) =>
  initRequest(
    AI_ASSISTANT_AI_FEATURES_FETCH,
    getAIAssistantEnabledFeaturesUrl(nodeId),
    RequestMethod.GET,
    undefined,
    t => ({
      onStart: t("modules.aiAssistant.aiSettings.fetchEnabledFeatures")
    }),
    undefined,
    baseUrl
  );
